module.exports = __webpack_public_path__ + "static/img/logo-7.136d2757.png";